import { useCallback, useMemo } from 'react';

export const useCopyToClipboard = () => {
	const copyToClipboard = useCallback(async (value): Promise<void> => {
		// check if the browser supports the clipboard API
		if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
			await navigator.clipboard.writeText(value);
		}
	}, []);

	return useMemo(() => ({ copyToClipboard }), [copyToClipboard]);
};
